module.exports = __webpack_public_path__ + "media/warranty-claim/photos-vent-27ef452d.png";